module.exports = __webpack_public_path__ + "img/Comic04-5.48a1dcca.png";